module.exports = __webpack_public_path__ + "0e474fda790b0c86ea1638c8a3b66aa4.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./components/Modal/images/large/salvador-dali.jpg
 ** module id = 405
 ** module chunks = 0
 **/